// src/components/Sections/WaitingPayment.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCurrency } from "../../context/currencyContext";

export default function WaitingPayment() {
  const { state } = useLocation();      // { orderId, amount }
  const navigate  = useNavigate();
  const [status, setStatus] = useState("pending");

  const { currency, setCurrency, convert } = useCurrency();

  /* ───── poll every 4 s until fulfilled ───── */
  useEffect(() => {
    const iv = setInterval(async () => {
      const res = await axios.get(`/api/orders/${state.orderId}/status`);
      if (res.data.status === "fulfilled") {
        clearInterval(iv);
        navigate("/payment-success", { state: { orderId: state.orderId } });
      }
      setStatus(res.data.status);
    }, 4000);

    return () => clearInterval(iv);
  }, [state.orderId, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: 80 }}>
      <h2>Waiting for Payment Confirmation</h2>
      <p>Please complete the payment in the opened window.</p>
      <p>
        <strong>Status:</strong> {status}
      </p>

      <p>
        <strong>Amount:</strong> {currency} {convert(state.amount)}
      </p>

      <div style={{ marginTop: 30 }}>
        <label>Currency:&nbsp;</label>
        <select value={currency} onChange={e => setCurrency(e.target.value)}>
          <option value="KES">KES</option>
          <option value="USD">USD</option>
        </select>

        <p style={{ fontSize: 13, marginTop: 8 }}>
          Prices may vary by exchange rate. Your licence and download link will be delivered after payment is confirmed.
        </p>
      </div>
    </div>
  );
}
